import Vue from 'vue'

Vue.mixin({
    methods: {

        capitalizeFirstLetter(str) 
        {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        numbToAlphabet(n)
        {
            return String.fromCharCode(n+65);
        },
        numberToPercent(n, total, fixed)
        {
            return total>0 ? (n/total*100).toFixed(fixed) : 0
        },
        checkImageUrl(url) 
        {
            return(url.match(/\.(jpeg|jpg|gif|png)$/) != null);
        },
        replaceGender(v)
        {
            if( v=='F' ) v = 'female';
            if( v=='M' ) v = 'male';
            
            return v;
        },
        
        slugify(str) 
        {
            str = str.replace(/^\s+|\s+$/g, ''); // trim
            str = str.toLowerCase();

            let from = [
                'а', 'б', 'в', 'г', 'д', 'е', 'ж', 'з', 'и', 'й', 'к', 'л', 'м', 'н', 'о', 'п', 'р', 'с', 'т', 'у', 'ф',
                'х', 'ц', 'ч', 'ш','щ', 'ъ', 'ь', 'ю', 'я'];
            let to = [
                'a', 'b', 'v', 'g', 'd', 'e', 'zh', 'z', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'r', 's', 't', 'u', 'f',
                'h', 'c', 'ch', 'sh','sht', 'y', '', 'iu', 'ia'];
            for (let key in from) {
                str = str.replace(new RegExp(from[key], 'g'), to[key])
            }

            str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                     .replace(/\s+/g, '_') // collapse whitespace and replace by -
                     .replace(/-+/g, '_'); // collapse dashes

            return str;
        } 
    }
})